import { findOrderStatusOrNull, OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { PartialDelivery } from '@/coreDomainsModule/entities/partialDelivery';
import { PartialDeliveryFactory } from '@/coreDomainsModule/factories/partialDeliveryFactory';
import { PartialDeliveryResponse } from '@/coreInfrastructureModule/axios/generated/orderManage/api';

/**
 * PartialDeliveryのアダプタ
 */
export class PartialDeliveryAdapter {
  /**
   * APIのレスポンスをPartialDeliveryに変換する
   * @param response - APIのレスポンス
   */
  public static adapt = (response: PartialDeliveryResponse): PartialDelivery => {
    return PartialDeliveryFactory.create({
      id: response.partialDeliveryId,
      organizationId: response.organizationId,
      orderId: response.orderId,
      aggregateBusinessId: response.aggregateBusinessId,
      partialDeliveryNumber: response.partialDeliveryNumber,
      orderCreationTime: response.orderCreationTime,
      deliveryDate: response.estimatedTimeOfArrival,
      orderAmount: response.orderAmount,
      orderStatus: findOrderStatusOrNull(response.partialDeliveryStatus) ?? OrderStatus.Unknown,
      isOutOfStockExpected: response.isOutOfStockExpected,
      lastUpdatedByUser: {
        email: response.lastUpdatedByUser?.id,
        name: response.lastUpdatedByUser?.name,
        organizationId: undefined,
        role: undefined,
        profile: undefined,
        createdAt: undefined,
        updatedAt: undefined,
      },
      createdAt: response.createdAt,
      updatedAt: response.updateAt,
    });
  };
}
